import request from '@/utils/request';
/**
 * @description  巨会养车 店铺 -- 列表
 */
export function shopListApi(params) {
  return request({
    url: '/admin/virtual/jh/store/list',
    method: 'get',
    params: params
  });
}
/**
 * 分页列表表头数量
 * @param data
 */
export function shopHeaderNumApi(params) {
  return request({
    url: "/admin/virtual/jh/store/header/num",
    method: 'get',
    params: params
  });
}

/**
 * @description  商户 店铺服务列表 -- 列表
 */
export function merchantStoreServiceListApi(data) {
  return request({
    url: '/merchant/virtual/store/service/setting/list',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户增加门店服务列表
 */
export function storeServiceSetting(data) {
  return request({
    url: '/merchant/virtual/store/service/setting',
    method: 'post',
    data: data
  });
}

/**
 * @description  商户 店铺 -- 列表
 */
export function merchantShopListApi(params) {
  return request({
    url: '/merchant/virtual/store/list',
    method: 'get',
    params: params
  });
}

/**
 * 商户分页列表表头数量
 * @param data
 */
export function merchantShopHeaderNumApi(params) {
  return request({
    url: "/merchant/virtual/store/header/num",
    method: 'get',
    params: params
  });
}

/**
 * @description 商户增加服务产品配置 -- 提交
 */
export function merchantAddServiceProductApi(data) {
  return request({
    url: '/merchant/virtual/store/service/product/add',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户增加服务列表 -- 提交
 */
export function merchantAddServiceApi(data) {
  return request({
    url: '/merchant/virtual/store/service/add',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户编辑服务列表 -- 提交
 */
export function merchantEditServiceApi(data) {
  return request({
    url: '/merchant/virtual/store/service/edit',
    method: 'post',
    data: data
  });
}

/**
 * @description  商户删除养车服务-- 列表
 */
export function merchantDeleteServiceApi(params) {
  return request({
    url: '/merchant/virtual/store/service/delete/' + params,
    method: 'get'
  });
}

/**
 * @description  商户养车 服务-- 列表
 */
export function merchantServiceListApi(params) {
  return request({
    url: '/merchant/virtual/store/service/list',
    method: 'get',
    params: params
  });
}

/**
 * @description  养车 服务-- 列表
 */
export function serviceListApi(params) {
  return request({
    url: '/admin/virtual/jh/service/list',
    method: 'get',
    params: params
  });
}

/**
 * @description  巨会养车 服务数据全量更新
 */
export function batchServiceApi() {
  return request({
    url: '/admin/virtual/jh/service/all',
    method: 'get'
  });
}

/**
 * @description  巨会养车 服务数据全量更新
 */
export function batchStoreApi() {
  return request({
    url: '/admin/virtual/jh/store/all',
    method: 'get'
  });
}
export function abcStoreByAdd(data) {
  return request({
    url: 'admin/merchant/maintenance/store/add',
    method: 'post',
    data: data
  });
}
export function abcStoreByEdit(data) {
  return request({
    url: 'admin/merchant/maintenance/store/edit',
    method: 'post',
    data: data
  });
}
export function abcStoreVerificationByEdit(data) {
  return request({
    url: 'admin/merchant/maintenance/store/verification/edit',
    method: 'post',
    data: data
  });
}
export function abcStoreByDelete(data) {
  return request({
    url: '/admin/merchant/maintenance/store/delete',
    method: 'post',
    data: data
  });
}
export function abcStoreByDetail(data) {
  return request({
    url: '/admin/merchant/maintenance/store/detail',
    method: 'post',
    data: data
  });
}
export function abcStoreListApi(params) {
  return request({
    url: "/admin/merchant/maintenance/store/list",
    method: 'get',
    params: params
  });
}
export function abcMapGeoApi(params) {
  return request({
    url: "/admin/merchant/maintenance/geo",
    method: 'get',
    params: params
  });
}

// 导入门店
export function virtualImportApi(data) {
  return request({
    url: '/merchant/virtual/import',
    method: 'post',
    data: data
  });
}

/**
 * 上传门店图片
 */
export function uploadObsApi(data) {
  return request({
    url: "/admin/upload/obs",
    method: 'post',
    data: data
  });
}

/**
 * @description 导入安全检测订单
 * @param data FormData包含了 file 和 serviceItemId
 */
export function importSecurityOrderApi(data) {
  return request({
    // 请确认后端Controller类上的RequestMapping，此处假设为 /admin/virtual/jh
    // 如果Controller没有类级别的mapping，则直接用 /order/import
    url: '/merchant/virtual/order/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    } // 确保明确声明，虽然axios通常会自动处理
  });
}